import { useEffect } from "react";
import useBumpToastStore from "./useBumpToastStore";

const useBumpToastHeight = (
	/**
	 * Amount to set the toast's height to
	 */
	height: number,
	enabled: boolean = true,
) => {
	useEffect(() => {
		if (enabled) {
			const { unsubscribe } = useBumpToastStore.getState().subscribe(height);
			return () => {
				unsubscribe();
			};
		}
		return;
	}, [height, enabled]);
};

export default useBumpToastHeight;
